import { Box, styled } from '@material-ui/core';
import { SButton } from '@setvi/shared/components';

export const AnchorBtn = styled(SButton)({
  padding: '0px 16px',
  borderRadius: 36,
  fontWeight: 600,

  '&:hover': {
    background: '#EBF5FF !important'
  }
});

export const Container = styled(Box)({
  padding: '12px 2px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 16,
  cursor: 'pointer',

  '&:hover': {
    background: '#EBF5FF',
    borderRadius: 16
  }
});

export const ImageContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 12
});

export const ImageBox = styled(Box)({
  minWidth: 110,
  width: 110,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

export const SubcontentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  gap: 8,
  alignItems: 'center',
  color: '#5D7083',
  marginBottom: 6
});

export const PrivateLabelBox = styled(Box)({
  fontSize: 12,
  wordBreak: 'keep-all',
  fontWeight: 600,
  color: '#fff',
  background: '#572BD3',
  borderRadius: 16,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '4px 8px'
});

export const SelectionBox = styled(Box)(({ theme }) => ({
  background: theme.palette.primary.main,
  borderRadius: '50%',
  width: 25,
  height: 25,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));
